"use client";

import type { FC } from "react";

import { cx } from "@/utils/cx";

const ICON_TRANSITION =
	"transition-[opacity,transform,filter] duration-300 ease-[cubic-bezier(0.2,0,0,1)]";

interface AnimatedIconToggleProps {
	openIcon: FC<{ className?: string }>;
	closeIcon: FC<{ className?: string }>;
	iconClassName?: string;
}

/** Menu ↔ close crossfade with scale and blur. Parent trigger must include `group`. */
export function AnimatedIconToggle({
	openIcon: OpenIcon,
	closeIcon: CloseIcon,
	iconClassName = "size-6",
}: AnimatedIconToggleProps) {
	return (
		<>
			<OpenIcon
				className={cx(
					iconClassName,
					ICON_TRANSITION,
					"group-aria-expanded:scale-25 group-aria-expanded:opacity-0 group-aria-expanded:blur-[4px]",
				)}
			/>
			<CloseIcon
				className={cx(
					iconClassName,
					"absolute",
					ICON_TRANSITION,
					"group-aria-expanded:blur-0 scale-25 opacity-0 blur-[4px] group-aria-expanded:scale-100 group-aria-expanded:opacity-100",
				)}
			/>
		</>
	);
}
